<template>
  <div>
    <a-row>
      <g-master name="Competencias"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="parentData"
                @action="masterAction"
                modalWidth="100%"
                ref="master"
      >
        <template slot="expandedRowRender" slot-scope="{text}">
          <template v-for="ve in master.valoresExpandidos">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </template>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Tipo de Competencia')"
                          :formItemConfig="fiOptions"
                          :decorator="['id_h_type_competency', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          :params="eva_tipo_competencia"
                          :selectedObj.sync="tipoCompetenciaSeleccionada">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Categoria Funcional y Nivel de Contribución')"
                          :formItemConfig="fiOptions"
                          :decorator="['id_h_category_level_competency', { rules: [{ required: true }] }]"
                          :params="categoriaParams"
                          :selectedObj.sync="categoriaCompetenciaSeleccionada">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Competencia')"
                          :formItemConfig="fiOptions"
                          :params="competenciasParams"
                          :selectedObj.sync="competenciaSeleccionada1"
                          :decorator="['id_competency', { rules: [{ required: true, message: 'Valor requerido' }] }]">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Perfil Del Rol Esperado')"
                          :formItemConfig="fiOptions"
                          :decorator="['role_profile', { rules: [{ required: false }] }]"
                          :params="eva_com_perfil_rol">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Evaluación Inicial Del Jefe')"
                          :formItemConfig="fiOptions"
                          :decorator="['initial_evaluation_boss', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="eva_comp_escala">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Evaluación Personal Inicial Del Colaborador')"
                          :formItemConfig="fiOptions"
                          :decorator="['initial_auto_evaluation_employee', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="eva_comp_escala">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Evaluación Inicial Ponderada')">
                <a-input disabled style="color: black"
                         v-decorator="['weighted_initial_evaluation', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Brecha Inicial')">
                <a-input disabled style="color: black"
                         v-decorator="['initial_difference', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-divider>PLAN DE ACCIÓN DESARROLLO DE LA COMPETENCIA</a-divider>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Plan de Acción')">
                <a-textarea autoSize
                            v-decorator="['action_plan', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Compromisos (¿Que haré?)')">
                <a-textarea autoSize
                            v-decorator="['commitments', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Contexto (Cómo lo  hare?)')">
                <a-textarea autoSize
                            v-decorator="['resources', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="Seguimiento" key="1">
          <eva_comp_seguimiento v-if="idSeleccionado" :id_competencia="idSeleccionado"></eva_comp_seguimiento>
          <span v-else>Seleccione una competencia para ver más.</span>
        </a-tab-pane>

        <a-tab-pane tab="Resultados Finales" key="2">
          <eva_comp_resultados_finales v-if="idSeleccionado && idEmpSeleccionado" :id_competencia="idSeleccionado"
                                       :id_emp="idEmpSeleccionado"></eva_comp_resultados_finales>
          <span v-else>Seleccione una competencia para ver más.</span>
        </a-tab-pane>
      </a-tabs>
    </a-row>
  </div>
</template>

<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    props: ['id_emp'],
    data () {
      return {
        seguir1: true,
        seguir2: true,
        seguir3: true,
        verListaCategoria: false,
        tipoCompetenciaSeleccionada: {},
        categoriaCompetenciaSeleccionada: {},
        competenciaSeleccionada: {},
        competenciaSeleccionada1: {},
        eva_tipo_competencia: {
          h_lookup_type: 'EVA_TIPO_COMPETENCIAS'
        },
        eva_comp_escala: {
          h_lookup_type: 'EVA_COMP_ESCALA',
          use_description: true
        },
        eva_com_perfil_rol: {
          h_lookup_type: 'PERFIL_DEL_ROL',
          use_equivalency: true
        },
        eva_categoria_nivel: {
          h_lookup_type: 'CATEGORIA_FUNCIONAL_NIVEL_CONTRIBUCION'
        },
        selOptions: {
          allowClear: true
        },
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'eva_competencias',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            allowSelect: true,
            selectedRows: [],
            columns: [
              {title: 'Tipo Competencia', dataIndex: 'tipo_competencia', align: 'center', sorter: true},
              {
                title: 'Categoria Funcional y Nivel Contribución',
                dataIndex: 'category_level_competency',
                align: 'center',
                sorter: true,
                width: 180
              },
              {title: 'Competencia', dataIndex: 'nombre_competencia', align: 'center', sorter: true},
              {title: 'Perfil Del Rol', dataIndex: 'role_profile', align: 'center', sorter: true},
              {
                title: 'Evaluación Inicial Jefe (60%)',
                dataIndex: 'initial_evaluation_boss',
                align: 'center',
                sorter: true,
                width: 130
              },
              {
                title: 'Evaluación Personal Inicial Colaborador (40%)',
                dataIndex: 'initial_auto_evaluation_employee',
                align: 'center',
                sorter: true,
                width: 160
              },
              {
                title: 'Evaluación Inicial Ponderada',
                dataIndex: 'weighted_initial_evaluation',
                align: 'center',
                sorter: true,
                width: 130
              },
              {title: 'Brecha Inicial', dataIndex: 'initial_difference', align: 'center', sorter: true},
              {
                title: 'Plan de acción desarrollo de la competencia',
                align: 'center',
                children: [
                  {title: 'Actividad', dataIndex: 'action_plan', align: 'center', sorter: true, width: 250},
                  {title: 'Compromisos', dataIndex: 'commitments', align: 'center', sorter: true, width: 250},
                  {title: 'Contexto', dataIndex: 'resources', align: 'center', sorter: true, width: 250}
                ]
              }
            ]
          },
          modalFieldsSetup: [
            {name: 'id_h_type_competency'},
            {name: 'id_competency'},
            {name: 'role_profile'},
            {name: 'initial_evaluation_boss'},
            {name: 'initial_auto_evaluation_employee'},
            {name: 'action_plan'},
            {name: 'commitments'},
            {name: 'resources'}
          ],
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ]
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'fieldsChange':
            if (!JsUtils.isEmpty(action.changedFields) && !JsUtils.isEmpty(action.changedFields.role_profile)) {
              console.log(action.changedFields.role_profile.value)
              this.role_profile = action.changedFields.role_profile.value
              // this.seguir1 = true
            }

            if (!JsUtils.isEmpty(action.changedFields) && !JsUtils.isEmpty(action.changedFields.initial_evaluation_boss)) {
              console.log(action.changedFields.initial_evaluation_boss.value)
              this.initial_evaluation_boss = action.changedFields.initial_evaluation_boss.value
              // this.seguir2 = true
            }

            if (!JsUtils.isEmpty(action.changedFields) && !JsUtils.isEmpty(action.changedFields.initial_auto_evaluation_employee)) {
              console.log(action.changedFields.initial_auto_evaluation_employee.value)
              this.initial_auto_evaluation_employee = action.changedFields.initial_auto_evaluation_employee.value
              // this.seguir3 = true
            }

            if (this.seguir1 && this.seguir2 && this.seguir3 &&
              !JsUtils.isEmpty(this.role_profile) && !JsUtils.isEmpty(this.initial_evaluation_boss) &&
              !JsUtils.isEmpty(this.initial_auto_evaluation_employee)) {
              this.calculaDatos(this.initial_evaluation_boss, this.initial_auto_evaluation_employee, this.role_profile)
              this.seguir1 = false
              this.seguir2 = false
              this.seguir3 = false
            }
            break
        }
      },
      calculaDatos: function (evaJefe, autoEvaEmp, perfilRol) {
        this.httpClient.getInstance().post('eva_competencias_calcula_datos', {
          initial_evaluation_boss: evaJefe,
          initial_auto_evaluation_employee: autoEvaEmp,
          role_profile: perfilRol
        })
          .then((response) => {
            this.$refs.master.modal.form.setFieldsValue({
              weighted_initial_evaluation: response.data[0]['eip'],
              initial_difference: response.data[0]['bi']
            })
            this.seguir1 = true
            this.seguir2 = true
            this.seguir3 = true
          })
          .catch((error) => {
            Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible calcular los valores, ' +
              'contacte al administrador.'))
            this.seguir1 = true
            this.seguir2 = true
            this.seguir3 = true
          })
      }
    },
    computed: {
      parentData () {
        return {
          id_emp: this.id_emp
        }
      },
      idSeleccionado () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      },
      idEmpSeleccionado () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id_emp : null
      },
      categoriaParams () {
        if (!this.$isEmpty(this.tipoCompetenciaSeleccionada)) {
          return {
            h_lookup_type: 'CATEGORIA_FUNCIONAL_NIVEL_CONTRIBUCION',
            id_h_lookup_father: this.tipoCompetenciaSeleccionada.value ? this.tipoCompetenciaSeleccionada.value : this.competenciaSeleccionada.value,
            ordenar_x_id_h_lookup: true
          }
        }
      },
      competenciasParams () {
        if (!this.$isEmpty(this.categoriaCompetenciaSeleccionada)) {
          return {
            h_lookup_type: 'EVA_COMPETENCIAS_FUN_ORG',
            id_h_lookup_father: this.categoriaCompetenciaSeleccionada.value ? this.categoriaCompetenciaSeleccionada.value : this.competenciaSeleccionada1.value,
            ordenar_x_id_h_lookup: true
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Evaluaciones/Complemento/Competencias.vue